var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNovaPostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2422 5.76159V9.91782H13.7692V5.76159H16.4684L13.2065 2.49542C13.0504 2.3384 12.8648 2.2138 12.6605 2.12879C12.4562 2.04376 12.2371 2 12.0159 2C11.7946 2 11.5755 2.04376 11.3712 2.12879C11.1669 2.2138 10.9813 2.3384 10.8252 2.49542L7.56329 5.76159H10.2422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75709 7.52528V16.4665L2.49512 13.1799C2.33819 13.0232 2.21367 12.8371 2.1287 12.6322C2.04374 12.4272 2 12.2075 2 11.9857C2 11.7638 2.04374 11.5441 2.1287 11.3391C2.21367 11.1342 2.33819 10.9481 2.49512 10.7914L5.75709 7.52528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7487 18.2384V14.078H10.2218V18.2384H7.52249L10.7844 21.5046C10.9406 21.6616 11.1261 21.7862 11.3304 21.8712C11.5347 21.9562 11.7538 22 11.9751 22C12.1963 22 12.4154 21.9562 12.6197 21.8712C12.8241 21.7862 13.0096 21.6616 13.1657 21.5046L16.4276 18.2384H13.7487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2462 16.479V7.53783L21.4878 10.8041C21.6482 10.9603 21.776 11.1468 21.8639 11.3528C21.9518 11.5588 21.9981 11.7801 22 12.0042C22.0019 12.2282 21.9594 12.4504 21.875 12.6579C21.7905 12.8653 21.6659 13.0539 21.5082 13.2129L18.2462 16.479Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaPostIcon);
export default __webpack_public_path__ + "static/media/NovaPostIcon.945886a87442925ff17a23f7b0b87de6.svg";
export { ForwardRef as ReactComponent };